// extracted by mini-css-extract-plugin
export default {"link":"QA-z","disabled":"RA-z"};